import React from 'react';

const Notifications = () => {
    return (
        <div className="page-container">
            <h2 className="page-header-title">Notifications</h2>
            <div className="card">
                <p>System alerts and reminders.</p>
            </div>
        </div>
    );
};

export default Notifications;
